import React, { useEffect, useRef, useState } from "react";
import { MARKVIEWED_ONDEMAND, ON_DEMANDSIGNALR, SIGNAL_R_TOKEN } from "../Utils/constants";
import { useDispatch } from "react-redux";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { isQ2Tenant } from "../Utils/ServiceProviders/q2";


const SignalR = (props) => {

    const dispatch = useDispatch();
    const viewedIds = useRef(new Set());
    const [connection, setConnection] = useState(null);
    const [signalAchDelayedMsg, setSignalAchDelayedMsg] = useState({})
    const [signalBankCalloutMsg, setSignalBankCalloutMsg] = useState([]);

    useEffect(() => {
        getSignalRDemand();
    }, [])

    useEffect(() => {
        console.log(signalBankCalloutMsg);
    }, [signalBankCalloutMsg])

    useEffect(() => {
        //console.log(signalAchDelayedMsg.length, signalBankCalloutMsg.length)
        if (signalAchDelayedMsg.length || signalBankCalloutMsg.length) {
            dispatch({
                type: 'SIGNALR_SET_TRIGGER',
                payload: {
                    signalAchDelayedMsg,
                    signalBankCalloutMsg,
                },
            });
        }
    }, [signalAchDelayedMsg, signalBankCalloutMsg, dispatch]);


    useEffect(() => {
        if (connection) {
            connection
                .start()
                .then(() => {
                    connection.on("ReceiveMessage", (res, messageId) => {
                        try {
                            let msgObj = {
                                "msg": JSON.parse(res),
                                "msgId": messageId
                            }
                            console.log('signalr received : ', msgObj);

                            if (msgObj.msg && msgObj.msg.messageType && msgObj.msg.messageType === "Q2Router") {
                                tectonQ2Router(msgObj);
                            } else if (msgObj.msg && msgObj.msg.messageType && msgObj.msg.messageType === "Q2Tecton") {
                                tectonCamden(msgObj);
                            } else if (msgObj.msg && msgObj.msg.Message && msgObj.msg.MessageType) {
                                setSignalBankCalloutMsg(prev => {
                                    if (prev.some(m => m.msgId === msgObj.msgId)) return prev;
                                    return [...prev, msgObj];
                                });
                            } else if (msgObj.msg && msgObj.msg.message && msgObj.msg.messageType) {
                                //console.log([...signalBankCalloutMsg, msgObj]);
                                setSignalBankCalloutMsg(prev => {
                                    if (prev.some(m => m.msgId === msgObj.msgId)) return prev;
                                    return [...prev, msgObj];
                                });
                            } else if (msgObj.msg && msgObj.msg.title) {
                                setSignalBankCalloutMsg(prev => {
                                    if (prev.some(m => m.msgId === msgObj.msgId)) return prev;
                                    return [...prev, msgObj];
                                });
                            }
                        } catch (e) { console.warn(e) }
                    });
                })
                .catch((error) => {
                    connection.stop();
                    connectSignalR();
                });
        }
    }, [connection]);// eslint-disable-line react-hooks/exhaustive-deps


    const connectSignalR = () => {
        const hubName = `BankCompletion`;
        props._list(SIGNAL_R_TOKEN, null, res => {
            const connect = new HubConnectionBuilder()
                .withUrl(res.connectionString, { accessTokenFactory: () => res.accessToken })
                .configureLogging(LogLevel.None)
                .withAutomaticReconnect()
                .build();

            setConnection(connect);
        })
    }

    const getSignalRDemand = () => {
        props._post(ON_DEMANDSIGNALR, null, (res) => {
            connectSignalR();
        })
    }

    const tectonQ2Router = (msgObj) => {
        //msgObj.msg.messageType
        markSingalMsgViewed(msgObj.msgId, -1)
        if (isQ2Tenant(props) && msgObj.msg?.details?.route) {
            console.warn(`tectonQ2Router calling dynamic ${msgObj.msg?.details?.route}`)
            window.tecton.sources.requestExtensionData({ ...msgObj.msg?.details }).then((xhr) => {
                // Do something with response
            }).catch((xhr) => {
                console.error(xhr);
                // Fires for non 200 series responses
            })

        } else if (isQ2Tenant(props)) {
            window.tecton.actions.notifyRefetchAccounts()
        } else {
            //console.warn(`tectonQ2Router calling dynamic failed`)
        }

    }

    const tectonCamden = (msgObj) => {

        if (isQ2Tenant(props)) {
            if (window.tecton && window.tecton.actions) {
                setTimeout(() => {
                    console.warn("tecton calling requestExtensionData refetch_hq")
                    window.tecton.sources.requestExtensionData({
                        route: 'refetch_hq',
                        body: null
                    }).then((xhr) => {
                        // Do something with response
                        setTimeout(() => {
                            console.warn("tecton calling notifyRefetchAccounts")
                            window.tecton.actions.notifyRefetchAccounts()
                            markSingalMsgViewed(msgObj.msgId, -1)
                        }, 5000)

                    }).catch((xhr) => {
                        console.error(xhr);
                        setTimeout(() => {
                            console.warn("tecton calling notifyRefetchAccounts")
                            window.tecton.actions.notifyRefetchAccounts()
                            markSingalMsgViewed(msgObj.msgId, -1)
                        }, 5000)
                        // Fires for non 200 series responses
                    })
                }, 7000);


            } else {
                console.warn(`tecton not able to notifyRefetchAccounts`)
            }
            // if (window.tecton && window.tecton.sources) {
            //   console.warn("tecton calling requestExtensionData")
            //   window.tecton.sources.requestExtensionData({
            //     route: 'create_user',
            //     body: null
            //   }).then((xhr) => {
            //     // Do something with response
            //   }).catch((xhr) => {
            //     console.error(xhr);
            //     // Fires for non 200 series responses
            //   })
            // } else {
            //   console.warn("tecton calling failed requestExtensionData")
            // }

        }
    }

    const markSingalMsgViewed = (notificationId, type) => {

        // prevent duplicate calls
        if (viewedIds.current.has(notificationId)) {
            return;
        }

        viewedIds.current.add(notificationId);

        props._post(MARKVIEWED_ONDEMAND(notificationId), null, res => {

            if (type === 0) {
                setSignalBankCalloutMsg(prev =>
                    prev.filter(msg => msg.msgId !== notificationId)
                );
            }

            if (type === 1) {
                setSignalAchDelayedMsg({})
            }


        }, err => {

        }, false)
    }

    return (
        <></>
    );
};

export default SignalR;
